import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import claimproassistNew from '../../../Assets/claimproassistNew.png'
import { MapContainer, TileLayer } from 'react-leaflet';
import axios from 'axios';
import { useNavigate } from "react-router-dom"
import HomeIcon from '@mui/icons-material/Home';
import CraneDriverDetails from './CraneDriverDetails';
import RidePopUp from './RidePopUp';
import BottomNavigationVendor from '../../../Component/Vendors/BottomNavigationVendor/BottomNavigationVendor';
import CaseFirstCard from '../../../Component/Vendors/FirstAppearComponent/CaseFirstCard/CaseFirstCard';
import { useWebSocket } from '../../../context/WebSocketContext';
import logo from '../../../Assets/navbar/logo.svg'
import { MdAccountCircle } from 'react-icons/md';
import CurrentWorkingCase from './CurrentWorkingCase.jsx'
import VendorDriverAllotedCase from './VendorDriverAllotedCase.jsx';
import DummyMapFromOLA from '../../../Component/Customers/DummyMapFromOLA.jsx';

const VendorDriverHome = () => {
    const navigate = useNavigate()
    const { sendMessage } = useWebSocket();
    const { messages } = useWebSocket()
    const [isNewCase, setNewCase] = useState(false)
    const [acceptedRequest, setAcceptedRequest] = useState(() => {
        const stored = sessionStorage.getItem('acceptedRequest');
        return stored ? JSON.parse(stored) : false;
    })

    console.log('isnewcaser', isNewCase)
    const [newCasesItems, setNewCasesItems] = useState([])
    console.log('newcaseseitesm', newCasesItems)
    const [totalAssignedCases, setTotalAssignedCases] = useState([]);
    const [approvedCase, setApprovedCase] = useState([])
    const [gotResponse, setGotResponse] = useState([]);
    const [getVendorData, setGetVendorData] = useState([]);
    const [driverAllotedCases, setDriverAllotedCases] = useState([]);

    console.log("driverAllotedCases", driverAllotedCases)

    const token = localStorage.getItem("token");
    const userId = localStorage.getItem("userId");
    const [data, setData] = useState([]);
    console.log("data", data)

    const [todayEarning, setTodayEarning] = useState(0);
    const [last7Days, setLast7Days] = useState(0);
    const [lastMonth, setLastMonth] = useState(0);
    const [lastYear, setLastYear] = useState(0);
    const [newmessg, setnewmessge] = useState(false)
    const [accidentVehicleCode, setAccidentVehicleCode] = useState(() => {
        return sessionStorage.getItem('accidentVehicleCode') || null;
    })

    useEffect(() => {
        messages.forEach((message) => {
            if (message.forPage === "crane-user-all-cases") {
                console.log('fetchedalledtodriver')
                fetchAllowedToDriver();
                
                messages.length = 0;
            }
            console.log("token", token, userId);
            if (token === "" || userId === "") {
                navigate("/");
            }
        })
    }, [messages])



    useEffect(() => {
        sendMessage({
            type: "join",
            userId: userId,
            userType: "crane",
        });
        const updateLocation = () => {
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(position => {
                    console.log("sendingLocatio", {
                        type: 'update-location-vendor',
                        userId: userId,
                        location: {
                            ltd: position.coords.latitude,
                            lng: position.coords.longitude
                        }
                    })
                    sendMessage({
                        type: 'update-location-vendor',
                        userId: userId,
                        location: {
                            ltd: position.coords.latitude,
                            lng: position.coords.longitude
                        }
                    })
                })
            }
        }

        const locationInterval = setInterval(updateLocation, 600000);
        updateLocation()

    }, [])

    useEffect(() => {
        if (token === '' || userId === '') {
            navigate('/');
        }
        console.log("hey here i am")
        fetchAssignedCases();
        fetchAllowedToDriver();
        getGotResponseVehicle()
        getVendorWholeDetails()
        getVendorById(userId)
    }, [token, userId]);



    useEffect(() => {
        if (data.length > 0) {
            const today = new Date();
            const startOfToday = new Date(today.getFullYear(), today.getMonth(), today.getDate());
            const startOf7DaysAgo = new Date(today);
            startOf7DaysAgo.setDate(today.getDate() - 7);
            const startOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
            const startOfYear = new Date(today.getFullYear(), 0, 1);

            let todayEarningSum = 0;
            let last7DaysSum = 0;
            let lastMonthSum = 0;
            let lastYearSum = 0;

            data.forEach((entry) => {
                const confirmDoneTime = new Date(entry.confirmDoneWorkingTime.replace('|', ' '));
                const charge = parseFloat(entry.charges);

                if (confirmDoneTime >= startOfToday) {
                    todayEarningSum += charge;
                }
                if (confirmDoneTime >= startOf7DaysAgo) {
                    last7DaysSum += charge;
                }
                if (confirmDoneTime >= startOfMonth) {
                    lastMonthSum += charge;
                }
                if (confirmDoneTime >= startOfYear) {
                    lastYearSum += charge;
                }
            });

            setTodayEarning(todayEarningSum);
            setLast7Days(last7DaysSum);
            setLastMonth(lastMonthSum);
            setLastYear(lastYearSum);
        }
    }, [data]);

    useEffect(() => {
        if (totalAssignedCases.length > 0) {
            console.log('totakassisdaf', totalAssignedCases)
            const filteredItems = totalAssignedCases.filter((caseItem) => caseItem?.details[0]?.firstResponseOn === null && caseItem?.details[0]?.timedOut === 0);
            console.log('filteredItems', filteredItems)
            setNewCasesItems(filteredItems);
            setNewCase(filteredItems.length > 0);
        } else {
            setNewCasesItems([]);
            setNewCase(false);
        }
    }, [totalAssignedCases])

    const fetchAssignedCases = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/assignedTasksForVendors/${userId}/${userId}`, { headers: { Authorization: `Bearer ${token}` } });
            console.log("Total assignedTasksMechanic", response.data.data);
            setTotalAssignedCases(response.data.data);
            //totalAssignedCases[i].details[0].vendorDecision != 'reject'

            response.data.data.map((item) => {
                if (item.details[0]?.customerAcceptedVendor && !item.details[0]?.vendorMoved) {
                    console.log("some inside fetchAssigneCases", item.details[0]?.customerAcceptedVendor, item.details[0]?.approvedReaching)
                    setApprovedCase([item]);
                }
            })

        } catch (error) {
            console.error("Failed to fetch assigned cases:", error);
        }
    };

    const fetchAllowedToDriver = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/fetchAllowedToDriver/${userId}/${userId}`, { headers: { Authorization: `Bearer ${token}` } });
            console.log("Total assignedTasksMechanic", response.data.data);
            setDriverAllotedCases(response.data.data);



        } catch (error) {
            console.error("Failed to fetch assigned cases:", error);
        }
    }
    const getGotResponseVehicle = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/getAssignedVehicleForDashboard/${userId}`);
            console.log("getAssignedVehicleForDashboard success", response.data.data);
            const filteredResponse = [];
            for (let i = 0; i < response.data.data.length; i++) {
                if (response.data.data[i].firstResponseOn != null) {
                    console.log("response.data.data.firstResponseOn", response.data.data[i].firstResponseOn);
                    filteredResponse.push(response.data.data[i]);
                }
            }
            setGotResponse(filteredResponse);
        } catch (error) {
            console.error("Failed to fetch existing data", error.response || error);
            if (error.response) {
                console.log("Error data:", error.response.data);
                console.log("Error status:", error.response.status);
                console.log("Error headers:", error.response.headers);
            } else {
                console.log("Error message:", error.message);
            }
        }
    };
    const getVendorWholeDetails = async () => {
        const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/getDriverWholeDetails/${userId}`, { headers: { Authorization: `Bearer ${token}` } });
        setData(response.data.data);
    };
    const getVendorById = async (userId) => {
        try {
            console.log("yeser")
            const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/getVendorDriver/${userId}`, { headers: { 'Authorization': `Bearer ${token}` } });
            console.log("caseFirstCardhser", response.data.data)
            setGetVendorData(response.data.data);
        } catch (error) {
            console.error("Error fetching all accident vehicle data", error);
        }
    };

    const handleBack = (accepted, accidentVehicleCode) => {
        console.log('accepted', accepted)
        getGotResponseVehicle()
        fetchAssignedCases()
        fetchAllowedToDriver();
        setNewCase(false)
        setAcceptedRequest(accepted);
        setAccidentVehicleCode(accidentVehicleCode)
        console.log('acceptedrequest', accepted, accidentVehicleCode)
        sessionStorage.setItem('acceptedRequest', JSON.stringify(accepted));
        sessionStorage.setItem('accidentVehicleCode', accidentVehicleCode);
    }


    return (
        <div className='h-screen'>
            <div style={{ zIndex: "999" }} className='fixed p-6 top-0 flex items-center justify-between w-screen'>
                <img className='w-16' src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/navbar/logo-navbar-compressed.png' alt="" />
                <Link className=' h-10 w-10 bg-white flex items-center justify-center rounded-full'>
                    {/* <HomeIcon style={{zIndex:"1000"}} className="text-lg font-medium" /> */}
                    <Link to="/state-selector">
                        <MdAccountCircle className="text-4xl text-gray-700 hover:text-[#21a6e9] transition duration-200" />
                    </Link>
                </Link>
            </div>
            <div className='h-3/5'>
                {/* <MapContainer zoom={10} center={[28.7041, 77.1025]} style={{ width: '100%', height: '60vh' }}>
                    <TileLayer
                        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                    />
                </MapContainer> */}
                <DummyMapFromOLA />
                {/* <img className='h-full w-full object-cover' src="https://miro.medium.com/v2/resize:fit:1400/0*gwMx05pqII5hbfmX.gif" alt="" /> */}
            </div>
            {getVendorData.length > 0 && (<div className='h-2/5 p-6'>
                <CraneDriverDetails driverName={getVendorData[0].driverName} isActive={getVendorData[0].isActive} dailyIncome={todayEarning} services={data.length} last7Days={last7Days} lastMonth={lastMonth} lastYear={lastYear} />
            </div>)}
            <div className='fixed w-full z-10 bottom-0 translate-y-full bg-white px-3 py-10 pt-12'>
                <RidePopUp />
            </div>
            {/* {isNewCase && (
                <div >
                    <CaseFirstCard data={newCasesItems} getBackPage={handleBack} />
                </div>
            )} */}
            {driverAllotedCases.length > 0 && (
                <VendorDriverAllotedCase incomingData={driverAllotedCases} />
            )}


        </div>
    );
};

export default VendorDriverHome;
